import { Input } from "@/components/ui/input"
import { Button } from "@/components/ui/button"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"
import type { BatchVariantRow, VariantOption } from "./types"

interface VariantRowProps {
  row: BatchVariantRow
  index: number
  variants: VariantOption[]
  onChange: (index: number, patch: Partial<BatchVariantRow>) => void
  onRemove: (index: number) => void
}

export default function VariantRow({
  row,
  index,
  variants,
  onChange,
  onRemove,
}: VariantRowProps) {
  if (row._destroy) return null

  return (
    <tr className="border-b border-gray-100">
      <td className="py-2 pr-2">
        <Select
          value={row.item_variant_id === "" ? undefined : String(row.item_variant_id)}
          onValueChange={(v) => onChange(index, { item_variant_id: Number(v) })}
        >
          <SelectTrigger className="h-9 w-64">
            <SelectValue placeholder="Choisir une variante" />
          </SelectTrigger>
          <SelectContent>
            {variants.map((v) => (
              <SelectItem key={v.id} value={String(v.id)}>
                {v.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </td>
      <td className="py-2 pr-2">
        <Input
          type="number"
          min="1"
          step="1"
          className="w-28"
          value={row.units_produced === "" ? "" : row.units_produced}
          onChange={(e) =>
            onChange(index, {
              units_produced: e.target.value === "" ? "" : Number(e.target.value),
            })
          }
        />
      </td>
      <td className="py-2 pr-2 text-right">
        <Button
          type="button"
          variant="ghost"
          size="sm"
          onClick={() => onRemove(index)}
        >
          Retirer
        </Button>
      </td>
    </tr>
  )
}
